
import * as Yup from 'yup';

//allows only dot and dash
const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
// const phoneNumberRegex = /^\+44[\s-]?(?:7\d{3}[\s-]?\d{6}|\d{2,4}[\s-]?\d{3,4}[\s-]?\d{3,4})$/;

const autoGetLocationFormSchema = {
    fullName: Yup.string()
        .required('Fullname is required')
        .min(2, 'Fullname should be at least 2 character long')
        .max(50, 'Fullname should not exceed 50 characters')
        .matches(/^[a-zA-Z\s]+$/, 'Name can only contain letters and spaces'),

    phoneNo: Yup.string()
        .nullable()
        .required(),
        // .test(
        //     'min-length',
        //     'Phone number must be at least 8 digits', // Adjust the minimum length message as needed
        //     (value) => !value || value.length >= 8 // Allows empty strings or checks for minimum length if entered
        // )
        // .max(20, 'Phone Number should not exceed 20 digits')
        // .test(
        //     'is-valid-phone',
        //     // 'Phone number must contain only numbers',
        //     (value) => !value || phoneNumberRegex.test(value) // Allows empty strings or matches the regex
        // ),
    address: Yup.mixed().required('Location is required'),
}

const manualGetLocationFormSchema = {
    fullName: Yup.string()
        .required('Fullname is required')
        .min(2, 'Fullname should be at least 2 character long')
        .max(50, 'Fullname should not exceed 50 characters')
        .matches(/^[a-zA-Z]+$/, 'Only alphabets are allowed'),
    phoneNo: Yup.string()
        .nullable()
        .required(),
        // .test(
        //     'min-length',
        //     'Phone number must be at least 8 digits', // Adjust the minimum length message as needed
        //     (value) => !value || value.length >= 8 // Allows empty strings or checks for minimum length if entered
        // )
        // .max(20, 'Phone Number should not exceed 20 digits')
        // .test(
        //     'is-valid-phone',
        //     // 'Phone number must contain only numbers',
        //     (value) => !value || phoneNumberRegex.test(value) // Allows empty strings or matches the regex
        // ),
    address: Yup.mixed().required('Location is required'),
    addressLine1: Yup.string()
        .required('Address is required')
        .min(2, 'Address should be at least 2 character long')
        .max(50, 'Address should not exceed 50 characters'),
    addressLine2: Yup.string()
        .nullable()
        .notRequired()
        .test(
            'min-length',
            'Address must be at least 3 character long', // Adjust the minimum length message as needed
            (value) => !value || value.length >= 3 // Allows empty strings or checks for minimum length if entered
        )
        .max(20, 'Address should not exceed 20 characters'),
    town: Yup.string()
        .required('Town is required')
        .min(2, 'Town should be at least 2 character long')
        .max(20, 'Town should not exceed 20 characters'),
    postalCode: Yup.string()
        .required('Postal code is required')
        .min(2, 'Postal Code should be at least 2 character long')
        .max(10, 'Postal Code should not exceed 10 characters'),
}

export { autoGetLocationFormSchema, manualGetLocationFormSchema }